/* eslint-disable import/prefer-default-export */
const BASE_URL = `${process.env.REACT_APP_AGENTIC_API_BASE_URL}`;
const CODE = process.env.REACT_APP_AGENTIC_API_CODE;

export function normalizeDocumentAgentResponse(apiResponse) {
  const data = apiResponse?.data || apiResponse?.output_text || null;

  // ---------- FALLBACK ----------
  if (!data) {
    return {
      type: "run_summary",
      summary: apiResponse?.response,
      counts: {},
      matches: [],
      clusters: [],
      caseRow: null,
      documentRows: [],
      outputText: apiResponse,
      agent: "DocumentProcessingAgent",
      intent: apiResponse?.output_text?.intent ?? undefined,
    };
  }

  // ---------- ERROR ----------
  if (apiResponse?.status === "failed") {
    return {
      type: "error",
      summary: apiResponse?.response,
      matches: [],
      clusters: [],
      outputText: apiResponse,
      agent: "DocumentProcessingAgent",
      intent: apiResponse?.output_text?.intent ?? undefined,
    };
  }

  // ---------- CASE SUMMARY ----------
  const caseSummary = data.caseSummary
    || data.case_summary || {};

  // ---------- COUNTS ----------
  const counts = {
    total_files:
      caseSummary.total_files
      ?? caseSummary.totalFiles
      ?? 0,
    processed:
      caseSummary.files_processed
      ?? caseSummary.filesProcessed
      ?? 0,
    acceptable:
      caseSummary.acceptable_count
      ?? caseSummary.acceptableCount
      ?? 0,
    low_quality:
      caseSummary.low_quality_count
      ?? caseSummary.lowQualityCount
      ?? 0,
    unreadable:
      caseSummary.unreadable_count
      ?? caseSummary.unreadableCount
      ?? 0,
    errors:
      caseSummary.error_count
      ?? caseSummary.errorCount
      ?? 0,
    average_quality_score:
      caseSummary.average_quality_score
      ?? caseSummary.averageQualityScore
      ?? null,
  };

  // ---------- SUMMARY ----------
  const summary = apiResponse?.response;

  // ---------- CASE LEVEL ROW ----------
  const caseId = data.caseId || data.case_id || "N/A";
  const criticalIssues = caseSummary.criticalIssues || caseSummary.critical_issues || [];
  const overallStatus = caseSummary.overallStatus || caseSummary.overall_status || "Unknown";

  const meta = data.caseMetadata || data.case_metadata || {};

  const caseRow = {
    caseId: meta.caseId || caseId || "N/A",
    submitDate: meta.submitDate || "N/A",
    origin: meta.origin || "N/A",
    firstName: meta.firstName || "N/A",
    lastName: meta.lastName || "N/A",
    caseManager: meta.caseManager || "N/A",
    updatedAt: meta.updatedAt || "N/A",
    notes: meta.notes || "N/A",
    status: overallStatus,
  };

  // ---------- DOCUMENT LEVEL ROWS ----------
  const fileResults = data.fileResults || data.file_results || [];

  const documentRows = fileResults.map((file) => {
    const fileUrlRaw = file.fileUrl || file.file_url || null;

    let fileUrl = null;

    if (fileUrlRaw) {
      const cleaned = fileUrlRaw.replace(/&amp;/g, '&');

      const absolute = cleaned.startsWith('http') || cleaned.startsWith('https') ? cleaned : `${BASE_URL.replace(/\/$/, '')}/${cleaned.replace(/^\//, '')}`;

      const sep = absolute.includes('?') ? '&' : '?';
      const withCode = CODE ? `${absolute}${sep}code=${encodeURIComponent(CODE)}` : absolute;

      fileUrl = withCode;
    }

    const qualityScore = file.qualityScore ?? file.quality_score ?? null;
    const blobUrl = file.blobUrl ?? file.blob_url ?? null;
    const blobName = file.blobName ?? file.blob_name ?? null;

    const structured = file.structuredData || file.structured_data || {};
    const documentType = structured.documentType || "N/A";

    const issues = Array.isArray(file.issues) ? file.issues : [];
    const description = issues.length
      ? issues.map((i) => i?.description).filter(Boolean).join("; ")
      : "No issues detected";

    return {
      fileUrl,
      filename: file.filename,
      documentName: file.filename,
      status: file.status,
      qualityScore,
      blobUrl,
      documentId: blobName,
      documentType,
      fileSize: "N/A",
      description,
      caseId,
    };
  });

  return {
    type: "run_summary",
    summary,
    counts,
    matches: [],
    clusters: [],
    caseRow,
    documentRows,
    outputText: apiResponse,
    agent: "DocumentProcessingAgent",
    intent: apiResponse?.output_text?.intent ?? undefined,
    caseId,
  };
}
